
  export enum permissions {
    PhotoApproval = 'photo-approve',
  }